import { CONSTANT } from "src/app/constant";
import { ReportSummary } from "src/app/models/models";
import { ReportSummaryLayoutContext } from "../report-summary-layout.types";
import { resolveTs1ReportUiKey } from "../ts1-report-summary.registry";
import { isTs1PfPmReportSummary } from "../ts1-report-preview.utils";

export function resolveTs1ReportSummaryLayout(report: ReportSummary): ReportSummaryLayoutContext | null {
	if (report.formType !== CONSTANT.FORM_TYPE.ts_1) {
		return null;
	}

	if (!isTs1PfPmReportSummary(report)) {
		return {
			layoutKey: "legacy",
			formType: report.formType,
			formVersion: report.formVersion,
		};
	}

	const uiKey = resolveTs1ReportUiKey(report.formVersion);
	if (uiKey === "v4") {
		return { layoutKey: "ts1-pfpm-v4", formType: report.formType, formVersion: 4 };
	}
	if (uiKey === "v3") {
		return { layoutKey: "ts1-pfpm-v3", formType: report.formType, formVersion: 3 };
	}

	return {
		layoutKey: "legacy",
		formType: report.formType,
		formVersion: report.formVersion,
	};
}
